(() => {
  'use strict';
  function initialize() {
    document.querySelectorAll('.sb-original-caregiver').forEach(root => {
      if (root.dataset.caregiverReady) return;
      root.dataset.caregiverReady = 'true';
      root.querySelectorAll('iframe[data-src],img[data-src]').forEach(media => {
        const source = media.dataset.src;
        if (!media.getAttribute('src') && source && /^https:\/\//.test(source)) {
          media.src = source;
        }
      });
      const dialog = root.querySelector('.sb-native-video-dialog');
      if (!dialog || root.dataset.videoReady) return;
      const frame = dialog.querySelector('iframe');
      const close = dialog.querySelector('button');
      if (!frame || !close || typeof dialog.showModal !== 'function') return;
      root.dataset.videoReady = 'true';
      root.addEventListener('click', event => {
        const link = event.target.closest('[data-sb-video]');
        if (!link || !root.contains(link)) return;
        const source = link.dataset.sbVideo;
        if (!source || !/^https:\/\/player\.vimeo\.com\//.test(source)) return;
        event.preventDefault();
        frame.src = source;
        dialog.showModal();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => frame.removeAttribute('src'));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
